<template>
  <router-link v-if="!disabled" :to="to">
    <slot />
  </router-link>
  <span v-else class="cursor-default">
    <slot />
  </span>
</template>

<script lang="ts">
import { PropType, defineComponent } from 'vue';

import { IGetAccountRouteHandler } from '@/bundles/App/helpers/accountRoute';

// A list's record link, which the account's permissions can close off. Vue
// Router 3 took a `disabled` prop on `<router-link>`; Router 4 has none, and
// passing one leaves the link working and renders `disabled` as an attribute,
// so a link that is not allowed renders as plain text instead.
export default defineComponent({
  name: 'RecordLink',

  props: {
    to: {
      type: [Object, String] as PropType<IGetAccountRouteHandler | string>,
      required: true,
    },
    disabled: Boolean,
  },
});
</script>
